import {
  CalendarIcon,
  Clock3Icon,
  HashIcon,
  LinkIcon,
  MessageCircleIcon,
  TypeIcon,
  ToggleLeftIcon,
  WalletIcon,
} from "lucide-react"
import { type LucideIcon } from "lucide-react"

import { CustomFieldValueType } from "@/shared/lib/attributes/custom-fields"

export enum AttributeCatalogCategory {
  TEXTUAL = "TEXTUAL",
  NUMERIC = "NUMERIC",
  LINKS = "LINKS",
  DATE_TIME = "DATE_TIME",
  BOOLEAN = "BOOLEAN",
}

export type AttributeCatalogItem = {
  type: CustomFieldValueType
  i18nKeyTitle: string
  i18nKeyDescription: string
  defaultLabelI18nKey: string
  icon: LucideIcon
  category?: AttributeCatalogCategory
}

export const ATTRIBUTE_CATALOG_ITEMS: AttributeCatalogItem[] = [
  {
    type: CustomFieldValueType.TEXT,
    i18nKeyTitle: "attributes.catalog.text.title",
    i18nKeyDescription: "attributes.catalog.text.description",
    defaultLabelI18nKey: "attributes.catalog.text.defaultLabel",
    icon: TypeIcon,
    category: AttributeCatalogCategory.TEXTUAL,
  },
  {
    type: CustomFieldValueType.TEXTAREA,
    i18nKeyTitle: "attributes.catalog.textarea.title",
    i18nKeyDescription: "attributes.catalog.textarea.description",
    defaultLabelI18nKey: "attributes.catalog.textarea.defaultLabel",
    icon: TypeIcon,
    category: AttributeCatalogCategory.TEXTUAL,
  },
  {
    type: CustomFieldValueType.NUMBER,
    i18nKeyTitle: "attributes.catalog.number.title",
    i18nKeyDescription: "attributes.catalog.number.description",
    defaultLabelI18nKey: "attributes.catalog.number.defaultLabel",
    icon: HashIcon,
    category: AttributeCatalogCategory.NUMERIC,
  },
  {
    type: CustomFieldValueType.MONEY,
    i18nKeyTitle: "attributes.catalog.money.title",
    i18nKeyDescription: "attributes.catalog.money.description",
    defaultLabelI18nKey: "attributes.catalog.money.defaultLabel",
    icon: WalletIcon,
    category: AttributeCatalogCategory.NUMERIC,
  },
  {
    type: CustomFieldValueType.PHONE,
    i18nKeyTitle: "attributes.catalog.phone.title",
    i18nKeyDescription: "attributes.catalog.phone.description",
    defaultLabelI18nKey: "attributes.catalog.phone.defaultLabel",
    icon: MessageCircleIcon,
    category: AttributeCatalogCategory.TEXTUAL,
  },
  {
    type: CustomFieldValueType.WHATSAPP,
    i18nKeyTitle: "attributes.catalog.whatsapp.title",
    i18nKeyDescription: "attributes.catalog.whatsapp.description",
    defaultLabelI18nKey: "attributes.catalog.whatsapp.defaultLabel",
    icon: MessageCircleIcon,
    category: AttributeCatalogCategory.LINKS,
  },
  {
    type: CustomFieldValueType.LINK,
    i18nKeyTitle: "attributes.catalog.link.title",
    i18nKeyDescription: "attributes.catalog.link.description",
    defaultLabelI18nKey: "attributes.catalog.link.defaultLabel",
    icon: LinkIcon,
    category: AttributeCatalogCategory.LINKS,
  },
  {
    type: CustomFieldValueType.DATE,
    i18nKeyTitle: "attributes.catalog.date.title",
    i18nKeyDescription: "attributes.catalog.date.description",
    defaultLabelI18nKey: "attributes.catalog.date.defaultLabel",
    icon: CalendarIcon,
    category: AttributeCatalogCategory.DATE_TIME,
  },
  {
    type: CustomFieldValueType.DATETIME,
    i18nKeyTitle: "attributes.catalog.datetime.title",
    i18nKeyDescription: "attributes.catalog.datetime.description",
    defaultLabelI18nKey: "attributes.catalog.datetime.defaultLabel",
    icon: Clock3Icon,
    category: AttributeCatalogCategory.DATE_TIME,
  },
  {
    type: CustomFieldValueType.BOOLEAN,
    i18nKeyTitle: "attributes.catalog.boolean.title",
    i18nKeyDescription: "attributes.catalog.boolean.description",
    defaultLabelI18nKey: "attributes.catalog.boolean.defaultLabel",
    icon: ToggleLeftIcon,
    category: AttributeCatalogCategory.BOOLEAN,
  },
]

export function getAttributeCatalogItem(type: CustomFieldValueType) {
  return ATTRIBUTE_CATALOG_ITEMS.find((item) => item.type === type)
}

